import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-ellipse.tsx
/**
* icon.24.ellipse
*
* Keywords: circle, outline, ring, round, shape, geometric, border, frame
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMThhNiA2IDAgMSAwIDAtMTIgNiA2IDAgMCAwIDAgMTJtMCAxYTcgNyAwIDEgMCAwLTE0IDcgNyAwIDAgMCAwIDE0IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2867
*/
const Icon24Ellipse = memo(function Icon24Ellipse(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0 1a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Ellipse };

//# sourceMappingURL=icon-24-ellipse.js.map